export default __webpack_public_path__ + "static/media/produits.f1e5b64f.xlsx";